module.exports = __webpack_public_path__ + "d52c21cef227bba94b4c4613b0c5eebd.svg";